import { createFileRoute } from '@tanstack/react-router'

import { insiderMembersSearchSchema } from '@/pages/insider/members-search'

/**
 * The list's URL contract lives on the LAYOUT route, not on the index, so the
 * drill-down inherits it: a `Link` that omits `search` is not "keep what is
 * there" but "clear it" — `applySearchMiddleware` returns an empty object — so
 * without a shared schema the two typed links below cannot hand the operator
 * back the page, filter and sort they were triaging by.
 */
export const Route = createFileRoute('/_layout/insider/members')({
  validateSearch: insiderMembersSearchSchema,
})
